export default __webpack_public_path__ + "static/media/zongshen.03f45066.png";